// extracted by mini-css-extract-plugin
var _1 = "jPrSt";
export { _1 as "authConfigInfo" }
